<template>
      <div v-if="displayOnboardInd">
        <Onboarding />
      </div>
      <div v-else>
      <div v-if="!forceUpdate">
      <ion-grid class="page-center-logo">
        <ion-row>
          <ion-col>
            <img src="/assets/images/logo/rapid.png" alt />
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
    <div v-if="forceUpdate" class="rp-mobile update-overlay">
      <div class="update-box">
        <ion-grid class="page-center-logo">
          <ion-row>
            <ion-col>
              <img src="/assets/images/logo/rapid.png" alt="Rapid Logo" class="logo" />
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="req-update">
              <h2>Update Required</h2>
              <p>You must update the app to continue.</p>
              <p>Avalilable Version {{ latestVersion}}</p>
              <ion-button @click="goToPlayStore" class="update-btn">Update Now</ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
        
      </div>
    </div>
    </div>
  </template>
  
  <script>
  import { AuthenticationService } from "../service/account/authenticator.service";
  import { LocalStorage } from "../data/localstorage";
  // import { AppUtils } from "../util/app-utils";
  // import { logger } from "../logger";
  
  // import { Plugins, StatusBarStyle } from '@capacitor/core';
  // const { StatusBar, StatusBarBackgroundColorOptions } = Plugins;
  import { App } from '@capacitor/app';
  import { Capacitor } from '@capacitor/core';
  import { AppLauncher } from "@capacitor/app-launcher";
  import Onboarding from "@/components/customer/Onboarding.vue";
import { IonButton, IonCol, IonGrid, IonRow } from "@ionic/vue";

  export default {
    name: "appLaunch",
    components: {
      Onboarding, IonGrid, IonRow, IonCol, IonButton
    },
    computed: {
      loggedIn: function() {
        return this.$store.state.user.isAuthenticated;
      },
      userRole: function() {
        return this.$store.state.user.userRole;
      }
    },
    data() {
      return {
        landpage: this.userRole ? this.userRole : "LOGIN",
        forceUpdate: false,
        latestVersion: "",
        displayOnboardInd : false,
        roleId: '',
        forceUpdateFlag: ''

      };
    },
    created() {
      // StatusBar.setBackgroundColor({ color: '#21B24B'});
      // this.landpage = 'LOGIN'
    },
    async mounted() {
      // const profileAndVehicleDetails = await new AuthenticationService().getUserProfileAndVehicleDetails();
      // if(profileAndVehicleDetails.displayOnboardInd) {
      //     this.displayOnboardInd = true;
      // } else {
         if (Capacitor.getPlatform() !== 'web') {
          this.forceUpdateFlag = await new AuthenticationService().getForceUpdateFlag();
          if(this.forceUpdateFlag.description == "Y") {
            const apkVersion = await App.getInfo();
            const result = await new AuthenticationService().getApkVersion();
            this.latestVersion = result.description;
            if(this.latestVersion != apkVersion.version) {
              this.forceUpdate = true; 
            } else {
              this.getUserDetails();
            }
          } else {
            this.getUserDetails();
          }
         
        } else {
          // this.forceUpdate = true; 
          this.getUserDetails();
        }
      // }

     
      
    },
    methods: {
      async getUserDetails() {
      //For performance issue set timeout is commented
        //setTimeout(async () => {
        const user = new LocalStorage().user;
        if (user) {
          this.roleId = localStorage.getItem('user.roleId')

            const profileAndVehicleDetails = await new AuthenticationService().getUserProfileAndVehicleDetails();
            if(profileAndVehicleDetails.displayOnboardInd) {
                this.displayOnboardInd = true;
            } else  {
              // if (this.$router.currentRoute.name == "appLaunch") {
                if (this.$route.name == "appLaunch") {
                  this.userLandingPage(user);
                }
            }
        } else {
          window.localStorage.clear();
          this.$router.push("/login");
        }
      //}, 5000);
      },
      async goToPlayStore() {
        const platform = Capacitor.getPlatform();

      //  if(platform == 'android') {
      //       window.open("https://play.google.com/store/apps/details?id=com.fenfeo.rapidevchargepd&hl=en",
      //       "_system");
      //   } else if(platform == 'ios')  {
      //      window.open("https://apps.apple.com/in/app/rapidevcharge/id1601374828",
      //       '_blank');
      //   }

      if(platform == 'android') {
        await AppLauncher.openUrl({url: "https://play.google.com/store/apps/details?id=com.fenfeo.rapidevchargepd&hl=en"})
      } else if(platform == 'ios') {
        await AppLauncher.openUrl({url: 'https://apps.apple.com/in/app/rapidevcharge/id1601374828'})
      }
        
      },
      async userLandingPage(user) {
        try {
          const userPermissions = await new AuthenticationService().permissionsOfUser(
            user
          );
          
          const isCustomer = userPermissions.find(
            userPermission => userPermission.id == "10|C"
          );
          const isAdmin = userPermissions.find(
            userPermission => userPermission.id == "10|T"
          );
          const isCorpUser = userPermissions.find(
            userPermission => userPermission.id == "130|C"
          )
          const isFenfeoService = userPermissions.find(
            userPermission => userPermission.id == "75|T"
          )
          if (isCustomer) {
            // this.$router.push("/customer/reservation");
            this.$router.push("/customer/reservation");
          } 
          // else if (isAdmin || isFenfeoService || isCorpUser) {
            // if (
            //   navigator.platform.indexOf("iPhone") != -1 ||
            //   navigator.platform.indexOf("iPod") != -1 ||
            //   navigator.platform.indexOf("iPad") != -1 ||
            //   navigator.platform.indexOf("Android") != -1
            // ) {
            //   this.$router.push("/common/gotoweblogin");
            // } else {
            //   this.$router.push("/admin/reservations");
            // }
          //   this.$router.push("/admin/adminDashboard");
          // }
          //  else if(isCorpUser) {
          //   this.$router.push("/corporate/cpoAdminDashboard");
          // } 
          else {
            this.$router.push("/admin/adminDashboard");
          }
        } catch (error) {
          
          // logger.info(error);
          window.localStorage.clear();
          this.$router.push("/login");
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .update-btn {
    --background: #21b24b 0% 0% no-repeat padding-box !important;
  }
  .page-center-logo {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 40px); 
  max-width: 480px;        
}

.req-update {
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);
}

.logo {
  display: block;
  margin: 0 auto 20px;
  max-width: 160px;
}
  </style>
  